import Intercom from 'vendor/Intercom/browser/Listener';

import Analytics from './Analytics';
import E from './EVENTS';

/**
 * This instance acts as the global application Analytics service.
 */
const analytics = new Analytics({
  listeners: {
    Intercom
  }
});

export default analytics;
export const EVENTS = E;
